import Structs.InventoryItem
import Utils.DatesManipulator
import kotlinx.serialization.json.*

@JsName("NKTypeConvertor")
object NKTypeConvertor {
    @JsName("toKotlinInt")
    fun toKotlinInt(n: Int): Int {
        return n.toLong().toInt()
    }

    @JsName("toKotlinLong")
    fun toKotlinLong(n: Number): Long {
        return n.toLong()
    }

    @JsName("toKotlinFloat")
    fun toKotlinFloat(n: Float): Float {
        return n.toDouble().toFloat()
    }

    @JsName("toKotlinList")
    fun toKotlinList(l: Array<Any>): List<Any> {
        return l.toList()

    }

    /**
     * Web sends plain JS objects from serializeInventory(); Kotlin code in
     * newInventoryNoteWeb reads InventoryItem fields and must receive real instances.
     */
    @JsName("toInventoryItemList")
    fun toInventoryItemList(l: Array<dynamic>): List<InventoryItem> {
        return l.map { obj -> inventoryItemFromJs(obj) }
    }

    private fun inventoryItemFromJs(obj: dynamic): InventoryItem {
        return InventoryItem(
            agent_id = jsToInt(obj.agent_id),
            product_id = jsToInt(obj.product_id),
            valueSum = jsToFloat(obj.valueSum),
            returnSum = jsToFloat(obj.returnSum),
            valueSumSec = jsToFloat(obj.valueSumSec),
            returnSumSec = jsToFloat(obj.returnSumSec),
            updated = (obj.updated as? String) ?: DatesManipulator.dateNow(),
            inventoryStart = jsToFloatOrNull(obj.inventoryStart),
            inventoryStart2 = jsToFloatOrNull(obj.inventoryStart2),
            amountDistribution = jsToFloatOrNull(obj.amountDistribution),
            amountDistribution2 = jsToFloatOrNull(obj.amountDistribution2),
            type = jsToInt(obj.type),
            inv_type = jsToInt(obj.inv_type),
            date = (obj.date as? String) ?: "",
            inventoryMatch = jsToFloatOrNull(obj.inventoryMatch),
            inventoryMatchSec = jsToFloatOrNull(obj.inventoryMatchSec),
            lastInventory = jsToFloatOrNull(obj.lastInventory),
            lastInventorySec = jsToFloatOrNull(obj.lastInventorySec),
        )
    }

    private fun jsToInt(value: dynamic): Int {
        if (value == null) return 0
        return when (value) {
            is Int -> value
            is Number -> value.toInt()
            else -> value.toString().toIntOrNull() ?: 0
        }
    }

    private fun jsToFloat(value: dynamic): Float {
        if (value == null) return 0f
        return when (value) {
            is Float -> value
            is Number -> value.toFloat()
            else -> value.toString().toFloatOrNull() ?: 0f
        }
    }

    private fun jsToFloatOrNull(value: dynamic): Float? {
        if (value == null) return null
        return when (value) {
            is Float -> value
            is Number -> value.toFloat()
            else -> value.toString().toFloatOrNull()
        }
    }

    @JsName("toKotlinByteArray")
    fun toKotlinByteArray(l: Array<Number>): ByteArray {
        return l.map { it.toByte() }.toByteArray()
    }
    @JsName("jsToKotlinMap")
    fun jsToKotlinMap(jsArray: dynamic): List<Map<String, Any>> {
        val jsonArray = jsArray as Array<dynamic>
        return jsonArray.map { jsObject ->
            val jsonString = JSON.stringify(jsObject)
            val jsonObject = Json.parseToJsonElement(jsonString) as JsonObject
            jsonObject.filter { (_, value) ->
                val primitive = value.jsonPrimitive
                ((primitive.contentOrNull ?: primitive.booleanOrNull ?: primitive.intOrNull
                ?: primitive.doubleOrNull ?: primitive.longOrNull) != null)
            }.mapValues { (_, value) ->
                val primitive = value.jsonPrimitive
                (primitive.contentOrNull ?: primitive.booleanOrNull ?: primitive.intOrNull
                ?: primitive.doubleOrNull ?: primitive.longOrNull ?: "")
            }.toMap()
        }
    }
}